module.exports = __webpack_public_path__ + "static/img/1.4f170776.png";